export class ReportTemplate {
    static fromExistingData(rep: any): ReportTemplate {
        const report = new ReportTemplate();
        if (rep.id) report.id = rep.id;
        if (rep.name) report.name = rep.name;
        if (rep.description) report.description = rep.description;
        if (rep.type) report.type = rep.type;
        if (rep.isPredefined) report.isPredefined = rep.isPredefined;
        if (rep.section) report.section = rep.section;
        if (rep.createdAt) report.createdAt = rep.createdAt;
        if (rep.createdBy) report.createdBy = rep.createdBy;
        if (rep.createdByName) report.createdByName = rep.createdByName;
        if (rep.conditions) report.conditions = rep.conditions;
        if (rep.filters) report.filters = rep.filters;
        if (rep.fields) report.fields = rep.fields;
        if (rep.functions) report.functions = rep.functions;
        if (rep.groupsBy) report.groupsBy = rep.groupsBy;
        if (rep.orderBy) report.orderBy = rep.orderBy;

        report.isCanEdit = rep.isCanEdit;
        report.isCanDelete = rep.isCanDelete;
        return report;
    }

    constructor(
        public id: number = null,
        public name: string = '',
        public description: string = '',
        public type: string = '',
        public isPredefined: boolean = false,
        public section: string = '',
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public createdBy: string = '',
        public createdByName: string = '',
        public createdAt: string = '',
        public conditions: Array<any> = [],
        public filters: Array<any> = [],
        public fields: Array<any> = [],
        public functions: Array<any> = [],
        public groupsBy: Array<any> = [],
        public orderBy: string = '',
        public reportTemplate: any = null,
        public links: any = null
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/ReportTemplate.ts